export const USER_TYPES = ["csn", "nissan", "nml", "region_manager"];
export const TICKET_EDIT_USER_TYPES = ["csn", "nissan"];
export const TICKET_MANAGEMENT_USER_TYPES = ["csn", "nissan", "callcenter"];
export const DEALER_TYPES = ["dealer"];
export const CALLCENTER_TYPES = ['callcenter'];
export const AREA_MANAGER_TYPES = ['area_manager'];
export const REGION_MANAGER_TYPES = ["region_manager"];
export const NML_TYPES = ["nml", "region_manager"];
export const ADMIN_TYPES = ['csn'];
export const QVOC_ADMIN_USER_TYPES = ["csn", "nissan"];
export const DEALER_MANAGEMENT_LEVEL = ["กรรมการผู้จัดการ", "ผู้จัดการ"];
export const TICKET_TYPES = ["showroom", "service"];
export const TICKET_SHOWROOM_STATUSES = ["W", "C", "S", "T", "B", "I"];
export const TICKET_SERVICE_STATUSES = ["W", "C", "S", "T", "B", "I"];
export const TICKET_STATUSES = ["W", "C", "S", "T", "B"];
export const TICKET_D_STATUS = "D";
export const TICKET_W_STATUS = "W";
export const TICKET_B_STATUS = "B";
export const TICKET_SOURCES = ["survey", "hotsheet", "callcenter"];
export const TICKET_SURVEY_SOURCE = "survey";
export const TICKET_HOTSHEET_SOURCE = "hotsheet";
export const TICKET_CALLCENTER_SOURCE = "callcenter";
export const TICKET_SERVICE_TYPE = "service";
export const TICKET_SHOWROOM_TYPE = "showroom";
export const TICKET_CLOSED_MONTHS = 1;
export const TICKET_CLOSED_DATES = 20;
export const STRING_TRIM_LENGTH = 80;

export const PERMISSION_LOGIN = [
	"ผู้จัดการศูนย์บริการ",
	"รักษาการผู้จัดการศูนย์บริการ/ผู้ช่วยผู้จัดการศูนย์",
	"ผู้จัดการขาย",
	"รักษาการผู้จัดการขาย/ผู้ช่วยผู้จัดการขาย",
	"ผู้จัดการทั่วไปฝ่ายการตลาด/หัวหน้าการตลาด/การตลาด",
	"ผู้จัดการทั่วไป/ผู้ช่วยผูัจัดการทั่วไป",
	"ลูกค้าสัมพันธ์ฝ่ายขาย",
	"หัวหน้าลูกค้าสัมพันธ์",
	"ผู้จัดการลูกค้าสัมพันธ์/ผู้ช่วยผู้จัดการ",
	"ลูกค้าสัมพันธ์/บัญชี/ประชาสัมพันธ์/อื่นๆ",
	"ลูกค้าสัมพันธ์ฝ่ายขายและบริการ",
	"ลูกค้าสัมพันธ์ฝ่ายบริการ",
	"GENERAL MANAGER",
	"กรรมการผู้จัดการ",
	"รองกรรมการ/ผู้ช่วย",
	"ประธานบริษัท/กรรมการบริหาร"
];

export const PERMISSION_TICKET_SHOWROOM_VIEW = [
	"ผู้จัดการขาย",
	"รักษาการผู้จัดการขาย/ผู้ช่วยผู้จัดการขาย",
	"ผู้จัดการทั่วไปฝ่ายการตลาด/หัวหน้าการตลาด/การตลาด",
	"ผู้จัดการทั่วไป/ผู้ช่วยผูัจัดการทั่วไป",
	"ลูกค้าสัมพันธ์ฝ่ายขาย",
	"หัวหน้าลูกค้าสัมพันธ์",
	"ผู้จัดการลูกค้าสัมพันธ์/ผู้ช่วยผู้จัดการ",
	"ลูกค้าสัมพันธ์/บัญชี/ประชาสัมพันธ์/อื่นๆ",
	"ลูกค้าสัมพันธ์ฝ่ายขายและบริการ",
	"ลูกค้าสัมพันธ์ฝ่ายบริการ",
	"GENERAL MANAGER",
	"กรรมการผู้จัดการ",
	"รองกรรมการ/ผู้ช่วย",
	"ประธานบริษัท/กรรมการบริหาร"
];
export const PERMISSION_TICKET_SERVICE_VIEW = [
	"ผู้จัดการศูนย์บริการ",
	"รักษาการผู้จัดการศูนย์บริการ/ผู้ช่วยผู้จัดการศูนย์",
	"ผู้จัดการทั่วไปฝ่ายการตลาด/หัวหน้าการตลาด/การตลาด",
	"ผู้จัดการทั่วไป/ผู้ช่วยผูัจัดการทั่วไป",
	"ลูกค้าสัมพันธ์ฝ่ายขาย",
	"หัวหน้าลูกค้าสัมพันธ์",
	"ผู้จัดการลูกค้าสัมพันธ์/ผู้ช่วยผู้จัดการ",
	"ลูกค้าสัมพันธ์/บัญชี/ประชาสัมพันธ์/อื่นๆ",
	"ลูกค้าสัมพันธ์ฝ่ายขายและบริการ",
	"ลูกค้าสัมพันธ์ฝ่ายบริการ",
	"GENERAL MANAGER",
	"กรรมการผู้จัดการ",
	"รองกรรมการ/ผู้ช่วย",
	"ประธานบริษัท/กรรมการบริหาร"
];

export const PERMISSION_GENERAL_REPORT = [
	"ผู้จัดการขาย",
	"รักษาการผู้จัดการขาย/ผู้ช่วยผู้จัดการขาย",
	"ผู้จัดการศูนย์บริการ",
	"รักษาการผู้จัดการศูนย์บริการ/ผู้ช่วยผู้จัดการศูนย์",
	"ผู้จัดการทั่วไปฝ่ายการตลาด/หัวหน้าการตลาด/การตลาด",
	"ผู้จัดการทั่วไป/ผู้ช่วยผูัจัดการทั่วไป",
	"ลูกค้าสัมพันธ์ฝ่ายขาย",
	"หัวหน้าลูกค้าสัมพันธ์",
	"ผู้จัดการลูกค้าสัมพันธ์/ผู้ช่วยผู้จัดการ",
	"ลูกค้าสัมพันธ์/บัญชี/ประชาสัมพันธ์/อื่นๆ",
	"ลูกค้าสัมพันธ์ฝ่ายขายและบริการ",
	"ลูกค้าสัมพันธ์ฝ่ายบริการ",
	"GENERAL MANAGER",
	"กรรมการผู้จัดการ",
	"รองกรรมการ/ผู้ช่วย",
	"ประธานบริษัท/กรรมการบริหาร"
];

export const PERMISSION_MANAGEMENT_REPORT = [
	"ผู้จัดการขาย",
	"ผู้จัดการศูนย์บริการ",
	"ผู้จัดการทั่วไปฝ่ายการตลาด/หัวหน้าการตลาด/การตลาด",
	"ผู้จัดการทั่วไป/ผู้ช่วยผูัจัดการทั่วไป",
	"GENERAL MANAGER",
	"กรรมการผู้จัดการ",
	"รองกรรมการ/ผู้ช่วย",
	"ประธานบริษัท/กรรมการบริหาร"
];

export const PERMISSION_TICKET_EDIT = [
	"ลูกค้าสัมพันธ์ฝ่ายขาย",
	"ลูกค้าสัมพันธ์/บัญชี/ประชาสัมพันธ์/อื่นๆ",
	"ลูกค้าสัมพันธ์ฝ่ายขายและบริการ",
	"ลูกค้าสัมพันธ์ฝ่ายบริการ",
	"GENERAL MANAGER",
	"กรรมการผู้จัดการ",
	"รองกรรมการ/ผู้ช่วย",
	"ประธานบริษัท/กรรมการบริหาร"
];

export const PERMISSION_TICKET_MANAGEMENT_EDIT = [
	"ผู้จัดการศูนย์บริการ",
	"รักษาการผู้จัดการศูนย์บริการ/ผู้ช่วยผู้จัดการศูนย์",
	"ผู้จัดการขาย",
	"รักษาการผู้จัดการขาย/ผู้ช่วยผู้จัดการขาย",
	"ผู้จัดการทั่วไปฝ่ายการตลาด/หัวหน้าการตลาด/การตลาด",
	"ผู้จัดการทั่วไป/ผู้ช่วยผูัจัดการทั่วไป",
	"หัวหน้าลูกค้าสัมพันธ์",
	"ผู้จัดการลูกค้าสัมพันธ์/ผู้ช่วยผู้จัดการ",
	"GENERAL MANAGER",
	"กรรมการผู้จัดการ",
	"รองกรรมการ/ผู้ช่วย",
	"ประธานบริษัท/กรรมการบริหาร"
];

export const PERMISSION_MULTI_BRANCHES_EDIT = [
	"ผู้จัดการทั่วไปฝ่ายการตลาด/หัวหน้าการตลาด/การตลาด",
	"ผู้จัดการทั่วไป/ผู้ช่วยผูัจัดการทั่วไป",
	"ผู้จัดการลูกค้าสัมพันธ์/ผู้ช่วยผู้จัดการ",
	"GENERAL MANAGER",
	"กรรมการผู้จัดการ",
	"รองกรรมการ/ผู้ช่วย",
	"ประธานบริษัท/กรรมการบริหาร"
];

export const SHOWROOM_MANAGER_TYPE = "ผู้จัดการขาย";
export const SERVICE_MANAGER_TYPE = "ผู้จัดการศูนย์บริการ";
